var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM7 4.90236C7 5.14121 7.09427 5.37041 7.26233 5.54013L11.359 9.99804L7.26233 14.4599C7.09427 14.6296 7 14.8588 7 15.0976C7 15.3365 7.09427 15.5657 7.26233 15.7354C7.34485 15.8192 7.44322 15.8858 7.5517 15.9312C7.66019 15.9766 7.77662 16 7.89423 16C8.01184 16 8.12828 15.9766 8.23676 15.9312C8.34525 15.8858 8.44362 15.8192 8.52614 15.7354L13.5214 10.6384C13.6892 10.4683 13.7833 10.239 13.7833 10C13.7833 9.76104 13.6892 9.53169 13.5214 9.36157L8.52614 4.26458C8.44362 4.18079 8.34525 4.11424 8.23676 4.06881C8.12828 4.02339 8.01184 4 7.89423 4C7.77662 4 7.66019 4.02339 7.5517 4.06881C7.44322 4.11424 7.34485 4.18079 7.26233 4.26458C7.09427 4.43431 7 4.66351 7 4.90236Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.7367ad0dbdf2ba58e1f46688dadf8ebd.svg";
export { ForwardRef as ReactComponent };